import { render, staticRenderFns } from "./InsuredImport.vue?vue&type=template&id=0356b28e&"
import script from "./InsuredImport.vue?vue&type=script&lang=js&"
export * from "./InsuredImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports